import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index.vue"),
    meta: { title: "Inicio — Aveo Perú" },
  },
  {
    path: "/pequenos-negocios",
    name: "PequenosNegocios",
    component: () => import("@/views/PequenosNegocios.vue"),
    meta: { title: "Pequeños Negocios" },
  },
  {
    path: "/descargas",
    name: "Descargas",
    component: () => import("@/views/Descargas.vue"),
    meta: { title: "Descargas" },
  },
  {
    path: "/tutoriales",
    name: "Tutoriales",
    component: () => import("@/views/Tutoriales.vue"),
    meta: { title: "Tutoriales" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.afterEach((to) => {
  document.title = to.meta.title || "AveoPerú";
});

export default router;
